export default __webpack_public_path__ + "static/media/check-icon-branco.92e9f32a.svg";